import axios from 'axios';
import {
    CreateGameInDTO,
    GameSessionDTO,
    StartRadomGameInDTO,
    GetNextChallengeInDTO,
    firstAndLastStroke as dto
} from "@haohan/game-dto"

export abstract class EngineAPI<
    CREATE_IN extends CreateGameInDTO = CreateGameInDTO,
    PROCESS_ACTION_IN = {},
    PROCESS_ACTION_OUT = {},
> {
    abstract dto: {
        CreateGameInDTO: { new(): CreateGameInDTO }
    };

    async randomGame(input: StartRadomGameInDTO): Promise<GameSessionDTO> {
        const res = await axios.post<GameSessionDTO>(
            '/api/game/start/random/', input
        );
        return res.data;
    }

    async processAction(
        publicHash: string,
        input: PROCESS_ACTION_IN
    ): Promise<PROCESS_ACTION_OUT> {
        const res = await axios.post<PROCESS_ACTION_OUT>(
            `/api/game/session/${publicHash}/action/process`, input
        );
        return res.data;
    }

    async nextChallenge(
        input: GetNextChallengeInDTO,
    ): Promise<dto.ProcessActionOutDTO> {
        const res = await axios.get<dto.NextChallengeOutDTO>(
            `/api/game/session/${input.publicHash}/challenge/next`
        );
        return res.data;
    }
}
